var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_7339)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_7339",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_7339)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_651_7339",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_651_7339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0H0V10.7781H10V0Z",
    fill: "#231D9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45993 2.64163L7.2124 1.88916L6.45993 1.13669L5.70747 1.88916L6.45993 2.64163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45993 5.68496L7.2124 4.9325L6.45993 4.18003L5.70747 4.9325L6.45993 5.68496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45993 8.7283L7.2124 7.97583L6.45993 7.22336L5.70747 7.97583L6.45993 8.7283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44626 2.64163L3.19873 1.88916L2.44626 1.13669L1.6938 1.88916L2.44626 2.64163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44626 5.68496L3.19873 4.9325L2.44626 4.18003L1.6938 4.93249L2.44626 5.68496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44626 8.7283L3.19873 7.97583L2.44626 7.22336L1.6938 7.97583L2.44626 8.7283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46628 4.16323L9.21875 3.41077L8.46628 2.6583L7.71381 3.41077L8.46628 4.16323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46628 1.12014L9.21875 0.367676L8.46628 -0.384792L7.71381 0.367676L8.46628 1.12014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46628 7.20657L9.21875 6.4541L8.46628 5.70163L7.71381 6.4541L8.46628 7.20657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46628 10.2499L9.21875 9.49744L8.46628 8.74497L7.71381 9.49744L8.46628 10.2499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4531 4.16323L5.20557 3.41077L4.4531 2.6583L3.70063 3.41077L4.4531 4.16323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4531 7.20657L5.20557 6.4541L4.4531 5.70163L3.70063 6.4541L4.4531 7.20657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4531 10.2499L5.20557 9.49744L4.4531 8.74497L3.70063 9.49744L4.4531 10.2499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.439915 4.16323L1.19238 3.41077L0.439915 2.6583L-0.312552 3.41077L0.439915 4.16323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.439915 7.20657L1.19238 6.4541L0.439915 5.70163L-0.312553 6.4541L0.439915 7.20657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.439915 10.2499L1.19238 9.49744L0.439915 8.74497L-0.312552 9.49744L0.439915 10.2499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7652 -0.102539H10V1.45169H24.7652V-0.102539Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8796 3.00598H10V4.56021H20.8796V3.00598Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8796 6.11426H10V7.66849H20.8796V6.11426Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7652 9.2229H10V10.7771H24.7652V9.2229Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6877 12.3313H0.208496V13.8855H24.6877V12.3313Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6877 15.4397H0.208496V16.9939H24.6877V15.4397Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6877 18.5482H0.208496V20.1024H24.6877V18.5482Z",
    fill: "#F0263C"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_7339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.8c097c220f524f9f95ad55aa3e21c87a.svg";
export { ForwardRef as ReactComponent };